import ExternalServiceProps from './parts/ExternalServiceProps';
import { is } from 'bpmn-js/lib/util/ModelUtil';

const LOW_PRIORITY = 500;

export default class ExternalServicePropertiesProvider {

  constructor(propertiesPanel, translate) {
    
    this.getGroups = function (element) {
      return function (groups) {
        // Add the new group
        if (is(element, 'bpmn:ServiceTask')) {
          groups.push(createExternalServiceGroup(element, translate));
        }
        return groups;
      };
    };

    // Use a lower priority to ensure it is loaded after the basic BPMN properties.
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
  }
}

ExternalServicePropertiesProvider.$inject = [ 'propertiesPanel', 'translate' ];

// Create the custom group called "External Service".
function createExternalServiceGroup(element, translate) {

  const externalServiceGroup = {
    id: 'externalService',
    label: translate('External Service'),  
    entries: ExternalServiceProps(element),
    // tooltip: translate('Group tooltip')
  };

  return externalServiceGroup;
}